import {
  COURSE_TITLE_CHANGED,
  COURSE_SUBJECT_CHANGED,
  COURSE_NUMBER_CHANGED,
  COURSE_UNIVERSITY_CHANGED,
  CLEAR_COURSE_FIELDS,
} from './action_types';

const initialState = {
  title: '',
  subject: '',
  number: '',
  univeristy: '',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case COURSE_TITLE_CHANGED:
      return { ...state, title: payload };
    case COURSE_SUBJECT_CHANGED:
      return { ...state, subject: payload };
    case COURSE_NUMBER_CHANGED:
      return { ...state, number: payload };
    case COURSE_UNIVERSITY_CHANGED:
      return { ...state, university: payload };
    case CLEAR_COURSE_FIELDS:
      return { ...state, ...initialState };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/courses/components/AddCourse/reducers.js